"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var GoogleAnalyticsEvents_1 = require("../../components/GoogleAnalyticsEvents");
var globals = __importStar(require("../_globals"));
jquery_1.default(window).on('load', function () {
    new GoogleAnalyticsEvents_1.GoogleAnalyticsEvents(globals.root);
});
